"use client";

import { usePathname, useRouter } from "next/navigation";
import { RiResetLeftFill } from "react-icons/ri";

const GlobalReset = () => {
  const router = useRouter();
  const pathname = usePathname();

  const resetFilters = () => router.push(pathname);

  return (
    <div className="flex items-center">
      <RiResetLeftFill
        title={"Sort"}
        aria-label={"Sort"}
        size={25}
        onClick={resetFilters}
        className="text-foreground-muted cursor-pointer hover:text-primary transition-all duration-200"
      />
    </div>
  );
};

export default GlobalReset;
